import { FILE_UPLOAD_ERRORS, DOCUMENT_SUPPORTED_FILES } from 'src/constants/constants';

export function formatFileSize(size) {
  if (size < 1000) {
    return '1.0KB';
  } else if (size < 1000000) {
    return `${Math.max(Math.round((size / 1048) * 10) / 10).toFixed(1)}KB`;
  } else {
    return `${Math.max(Math.round((size / 1048576) * 10) / 10).toFixed(1)}MB`;
  }
}

export function getFileTypes(files) {
  return files.map(file => file.type);
}

export function getFileIcon(fileName, files) {
  if (fileName === undefined) {
    return '';
  }
  const query = fileName.substring(fileName.lastIndexOf('.') + 1);
  const index = files.findIndex(file => `.${query}`.toLowerCase() === file.type.toLowerCase());
  if (files[index]) {
    return files[index].icon === 'file' ? 'mdi-file' : `mdi-file-${files[index].icon}`;
  } else {
    return '';
  }
}

export function fileRejectErrorType(rejectedFile,acceptedFileTypes) {
  const fileName = rejectedFile.name;
  const fileSize = rejectedFile.size;
  const query = fileName.substring(fileName.lastIndexOf('.'));
  let index, supportedfileTypes;
  if( typeof acceptedFileTypes === "string"){
    supportedfileTypes= acceptedFileTypes.split(',');
  }else{
    supportedfileTypes = acceptedFileTypes;
  }
  if(supportedfileTypes.length>0)
    index = supportedfileTypes.findIndex(fileType => query.toLowerCase() === fileType.toLowerCase());
  else
    index = DOCUMENT_SUPPORTED_FILES.findIndex(fileType => query.toLowerCase() === fileType.toLowerCase());

  return index >= 0 && fileSize !== 0 ? FILE_UPLOAD_ERRORS.LIMIT_EXCEEDED : index >= 0 && fileSize === 0 ?  FILE_UPLOAD_ERRORS.UNSUPPORTED_ZER0_FILE_SIZE :
  FILE_UPLOAD_ERRORS.UNSUPPORTED;
}

export function fileRejectCustomErrorType(rejectedFile, supportedFiles) {
  const fileName = rejectedFile.name;
  const query = fileName.substring(fileName.lastIndexOf('.'));
  const index = supportedFiles.findIndex(fileType => query.toLowerCase() === fileType.toLowerCase());
  return index >= 0 ? FILE_UPLOAD_ERRORS.LIMIT_EXCEEDED : FILE_UPLOAD_ERRORS.UNSUPPORTED;
}
export function fileRejectCustomErrorMessageType(rejectedFile, supportedFiles) {
  const fileName = rejectedFile.name;
  const query = fileName.substring(fileName.lastIndexOf('.'));
  const index = supportedFiles.findIndex(fileType => query.toLowerCase() === fileType.toLowerCase());
  return index >= 0 ? FILE_UPLOAD_ERRORS.LIMIT_EXCEEDED : FILE_UPLOAD_ERRORS.UNSUPPORTED_PREREGISTRATE;
}





// WEBPACK FOOTER //
// ./src/helpers/upload.js